// @flow
import { Provider } from 'react-redux';

import { linkButton } from '@styles/buttons';

type TProps = {
  bandSku: string,
  ringSize: string
};

function AddMatchingBandLink({ bandSku, ringSize }: TProps) {
  return (
    <div style={{ marginTop: 20 }}>
      <form action={`/orders/add_to_cart`} method='POST'>
        <input
          type='hidden'
          name='authenticity_token'
          value={
            typeof document !== 'undefined' && ReactOnRails.authenticityToken()
          }
        />
        <input type='hidden' name='id' value={bandSku} />
        <input type='hidden' name='item_type' value='band' />
        <input type='hidden' name='ring_size' value={ringSize} />
        <button type='submit' style={linkButton}>
          Add the matching band
        </button>
      </form>
    </div>
  );
}

export default (props: TProps) => {
  const store = ReactOnRails.getStore('SharedReduxStore');

  return (
    <Provider store={store}>
      <AddMatchingBandLink {...props} />
    </Provider>
  );
};
